import * as React from 'react';

import {scroller} from 'react-scroll';

import Musthead from '@app/components/UI/MustHead/Musthead';
import RichText from '@app/components/UI/RichText/RichText';
import LinkBlockSmall from '@app/components/UI/LinkBlock/LinkBlockSmall';
import withSeo from '@app/components/LocalCommon/HigherOrderComponents/WithSeo';
import NavTabs from '@app/components/UI/NavTabs/NavTabs';
import listenerForBrowser from '@app/components/Pages/listenerForBrowser';
import CardLinks from '@app/components/UI/CardLinks/CardLinks';

import {
	petMemorialKeepsakesText,
	additionalServices,
	armsOfLoveText,
	disclaimerAddText,
	disclaimerText,
	disclaimerTitle,
	emergencyService,
	individualSessionText,
	navItems,
	petLossGroupJoinText,
	petLossGroupLinkItems,
	petLossGroupText
} from './PetLossSupportGroupContent';

const PetLossSupportGroup = () => {
	const [currentIndex, setCurrentIndex] = React.useState(0);
	const [navCollapse, setNavCollapse] = React.useState(false);

	const groupRef = React.useRef<any>();
	const journeyRef = React.useRef<any>();
	const personalRef = React.useRef<any>();
	const keepsakesRef = React.useRef<any>();

	const onSetIssue = (index) => {
		const refs = [journeyRef, personalRef, groupRef, keepsakesRef];
		setCurrentIndex(index);
		refs[index].current?.scrollIntoView({block: 'center', inline: 'nearest'});
	};

	React.useEffect(() => {
		const mql = window.matchMedia('screen and (max-width: 768px)');

		const listenerFunc = () => {
			if (mql.matches) {
				setNavCollapse(true);
			} else {
				setNavCollapse(false);
			}
		};
		listenerFunc();
		listenerForBrowser(mql, listenerFunc);
	}, []);

	return (
		<div className="our-services pet-loss-group">
			<Musthead
				title="Pet Loss Support"
				imageSrc={require('@app/content/petLossGroupHeader.jpg')}
				text="We’re here to do this together, and we’re here to give you permission to grieve."
				quoteAuthor="Dr. Dani McVety"
				buttonText={<a href="mailto:PetLossSupport@lapoflove.com">
					<button type={'button'} className="btn btn-sm btn-primary">Contact Us</button>
				</a>}
				imageAlt="Pet loss support"
			/>
			<NavTabs
				navItems={navItems}
				currentIndex={currentIndex}
				onSetIssue={onSetIssue}
				navCollapse={navCollapse}
				onChange={onSetIssue}
			/>
			<RichText
				title="Arms of Love - Understanding the Pet Loss Journey Course"
				text={armsOfLoveText}
				name={navItems[0].name}
				refRichText={journeyRef}
			/>
			<RichText
				title="Individual Pet Loss Support Session"
				text={individualSessionText}
				name={navItems[1].name}
				refRichText={personalRef}
			/>
			<RichText
				title="Pet Loss Support Groups"
				text={petLossGroupText}
				name={navItems[2].name}
				refRichText={groupRef}
			/>
			<RichText text={petLossGroupJoinText}/>
			<RichText
				title="Memorialize your pet"
				text={petMemorialKeepsakesText}
				name={navItems[3].name}
				refRichText={keepsakesRef}
			/>
			<RichText
				title={disclaimerTitle}
				text={disclaimerText}
			/>

			<CardLinks list={emergencyService}/>

			<RichText
				text={disclaimerAddText}
			/>

			<CardLinks list={additionalServices}/>
			<LinkBlockSmall items={petLossGroupLinkItems}/>
		</div>
	);
};

export default withSeo(PetLossSupportGroup, state => state.petLossSupportGroupPage, 'petLossSupportGroupPage', 'our-services/pet-loss-support');
